import Col from "components/ui-elements/Col";
import Row from "components/ui-elements/Row";
import { MyConst } from "data/MyConst";
import useAxiosFunction from "hooks/useAxiosFunction";
import useMsgBox from "hooks/useMsgBox";
import React, { useEffect, useState } from "react";
import { StyledDropZone } from "react-drop-zone";
import "react-drop-zone/dist/styles.css";
import { useDispatch } from "react-redux";
import { utilityAction } from "reduxStore";

const PhotoDropUpload = (props) => {
  const dispatch = useDispatch();

  let {
    label = "Upload/Drop Foto di Sini",
    caption = "",
    allowedExtentions = ["jpg", "jpeg", "png"],
    data = {},
    name = "foto",
    dropname = "foto",
    url = "",
    auth = true,
    onError = () => {},
    onSuccess = () => {},
    fontSize = "15px",
    padding = "1em",
    setValue = () => {},
    validation,
    value = "",
    register = () => ({}),
    error,
    previewWidth = 120,
    previewHeight = 120,
    ...rest
  } = props;

  dropname = dropname ? dropname : name;
  if (!data?.name) {
    data["name"] = dropname;
  }

  const [showMsg] = useMsgBox();
  const [resp, errorf, loading, axiosFetch] = useAxiosFunction();

  const [filename, setFilename] = useState(value);
  const [displayLabel, setDisplayLabel] = useState(label);

  const doUpload = async (file) => {
    dispatch(utilityAction.setLoading(true));

    const originalName = file?.name || "";
    const ext = originalName.split(".").pop().toLowerCase();
    const allowed = allowedExtentions.some(
      (x) => (x + "").toLowerCase() === ext,
    );

    if (!allowed) {
      await showMsg(
        "Informasi",
        "Anda hanya diperkenan mengupload file bertipe: " +
          allowedExtentions.join(", "),
      );
      dispatch(utilityAction.setLoading(false));
      return;
    }

    const formData = new FormData();
    formData.append(dropname, file);
    Object.keys(data).forEach((key) => formData.append(key, data[key]));

    const hasil = await axiosFetch({
      method: "POST",
      url: url,
      data: formData,
      auth,
      multipart: true,
    });

    dispatch(utilityAction.setLoading(false));

    if (hasil?.data?.success === true) {
      const newFilename = hasil?.data?.filename;
      setValue(name, newFilename);
      setFilename(newFilename);
      setDisplayLabel(originalName || label);
      await showMsg("Informasi", "Foto berhasil diupload.");
      onSuccess(newFilename, hasil);
      return;
    }

    if (hasil?.data?.success === false) {
      await showMsg("Error", hasil?.message);
      onError(hasil?.message);
      return;
    }

    await showMsg("Error", "Tidak terhubung ke server!");
    onError("Tidak terhubung ke server!");
  };

  useEffect(() => {
    if (value) {
      setFilename(value);
      setDisplayLabel(value);
    } else {
      setFilename("");
      setDisplayLabel(label);
    }
  }, [label, value]);

  const location = data?.location || "profile";
  const src = filename ? `${MyConst.URLASET}/${location}/${filename}` : "";

  return (
    <div>
      <Row>
        <Col size={12}>
          <input type="hidden" {...rest} {...register(name, validation)} />
          <StyledDropZone
            style={{ fontSize: fontSize, padding: padding }}
            onDrop={(file) => doUpload(file)}
          >
            <div style={{ textAlign: "center" }}>
              {filename ? (
                <>
                  <img
                    alt="foto"
                    src={src}
                    style={{
                      display: "block",
                      margin: "0 auto 10px auto",
                      width: previewWidth,
                      height: previewHeight,
                      objectFit: "cover",
                      borderRadius: 6,
                      border: "1px solid #ddd",
                      background: "#fff",
                    }}
                  />
                  <div style={{ fontSize: "12px", wordBreak: "break-word" }}>
                    {filename}
                  </div>
                  <div style={{ marginTop: 6, fontSize: "12px", opacity: 0.8 }}>
                    {caption}
                  </div>
                </>
              ) : (
                <>
                  <div>{displayLabel}</div>
                </>
              )}
            </div>
          </StyledDropZone>
          <center>
            {error && <span className="text-danger">{error}</span>}
          </center>
        </Col>
      </Row>
    </div>
  );
};

export default PhotoDropUpload;
